<mat-toolbar color="primary">
    <span class="logo" (click)="logo()">QR Money Solutions</span>
    <span class="spacer"></span>
    <notifications class="print"></notifications>
    <span class="user-name print">{{loggedUserName}}</span>
    <account-menu class="print"></account-menu>
</mat-toolbar>